// extracted by mini-css-extract-plugin
export default {"headsUpDrawerContainer":"cRaJck","headsUpDrawerButton":"vNnhsb","headsUpDrawerHeading":"CwpytJ","headsUpDrawerText":"XdCVSz","disabled":"fsqiEw","buttonClassHeadsUp":"_ZD3aP"};